
import { Waves, GlassWater, Utensils, Train } from "lucide-react";

export interface Facility {
  label: string;
  icon: any;
  priority: number;
}

export const facilityMapping: Record<string, Facility> = {
  swimming_pool: {
    label: "Zwembad",
    icon: Waves,
    priority: 1
  },
  bar: {
    label: "Bar",
    icon: GlassWater,
    priority: 2
  },
  restaurant: {
    label: "Restaurant",
    icon: Utensils,
    priority: 3
  },
  train_included: {
    label: "Trein inbegrepen",
    icon: Train,
    priority: 4
  }
};

export const extractFacilities = (vacation: any): Facility[] => {
  const facilities: Facility[] = [];
  
  console.log('Processing vacation facilities:', {
    swimmingPool: vacation.swimmingPool,
    trainIncluded: vacation.trainIncluded,
    facilities: vacation.facilities,
    all_inclusive: vacation.all_inclusive,
    adults_only: vacation.adults_only
  });
  
  // Check boolean fields
  if (vacation.swimmingPool === true || vacation.swimmingPool === 'Yes' || vacation.swimmingPool === 'true') {
    facilities.push(facilityMapping.swimming_pool);
  }
  
  if (vacation.trainIncluded === true || vacation.trainIncluded === 'Yes' || vacation.trainIncluded === 'true') {
    facilities.push(facilityMapping.train_included);
  }
  
  // Parse facilities string field - look for various patterns
  if (vacation.facilities && typeof vacation.facilities === 'string') {
    const facilityString = vacation.facilities.toLowerCase();
    
    // Check for swimming pool in facilities string
    if (facilityString.includes('zwembad') || facilityString.includes('pool') || facilityString.includes('swimming')) {
      const exists = facilities.some(f => f.label === facilityMapping.swimming_pool.label);
      if (!exists) {
        facilities.push(facilityMapping.swimming_pool);
      }
    }
    
    // Check for bar
    if (facilityString.includes('bar')) {
      facilities.push(facilityMapping.bar);
    }
    
    // Check for restaurant
    if (facilityString.includes('restaurant') || facilityString.includes('dining') || facilityString.includes('eten')) {
      facilities.push(facilityMapping.restaurant);
    }
    
    // Check for train
    if (facilityString.includes('trein') || facilityString.includes('train') || facilityString.includes('transport')) {
      const exists = facilities.some(f => f.label === facilityMapping.train_included.label);
      if (!exists) {
        facilities.push(facilityMapping.train_included);
      }
    }
  }
  
  // For testing purposes, let's also add some facilities based on other vacation properties
  // This will help us see more variety in the badges
  if (vacation.all_inclusive === 'Yes' && Math.random() > 0.5) {
    const hasBar = facilities.some(f => f.label === facilityMapping.bar.label);
    const hasRestaurant = facilities.some(f => f.label === facilityMapping.restaurant.label);
    
    if (!hasBar) {
      facilities.push(facilityMapping.bar);
    }
    if (!hasRestaurant) {
      facilities.push(facilityMapping.restaurant);
    }
  }
  
  // Remove duplicates and sort by priority
  const uniqueFacilities = facilities.filter((facility, index, self) => 
    index === self.findIndex(f => f.label === facility.label)
  );
  
  console.log('Extracted facilities:', uniqueFacilities.map(f => f.label));
  
  return uniqueFacilities.sort((a, b) => a.priority - b.priority);
};
